const alignArtistHeight = () => {
  const hgt = {
    init: () => {
      hgt.vals = {
        BREAK: 767,
        win: $(window).width(),
      };
      hgt.tgts = $('.artist-blocks').find('.thumb-box');

      // ロード時にブレイクポイントより狭い場合
      if (hgt.vals.win < hgt.vals.BREAK) hgt.align();
      // リサイズ時
      let timer = false;
      $(window).on('resize', () => {
        hgt.vals.win = $(window).width();
        hgt.tgts.height('auto');

        if (timer !== false) clearTimeout(timer);
        timer = setTimeout(() => {
          if (hgt.vals.win < hgt.vals.BREAK) {
            hgt.align();
          }
        }, 200);
      });
    },

    align: () => {
      hgt.tgts.each((i, tgt) => {
        const myHeight = $(tgt).height();
        hgt.tgts.height(myHeight + 1.5);
      });
    },

  };
  hgt.init();
};


$(document).on('ready', () => {
  alignArtistHeight();
});

// スライド(swiper)
var swiper = new Swiper('.swiper-container', {
  loop: true,
  slidesPerView: 3,
  nextButton: '.swiper-button-next',
  prevButton: '.swiper-button-prev',
  breakpoints: {
    768: {
      loop: true,
      slidesPerView: 2,
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
    }
  }
});


// 固定メニュー(PC時)
if(!navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)){
  var $win = $(window),
      $contents = $('.adjust'),
      $contents_osaka = $('.adjust_osaka'),
      $nav = $('.nav-main'),
      navHeight = $nav.outerHeight(),
      navPos = $nav.offset().top,
      fixedClass = 'fixed';

  $win.on('load scroll', function() {
    var value = $(this).scrollTop();
    if ( value > navPos ) {
      $nav.addClass(fixedClass);
      // $contents.css('padding-top', '6%');
      // $contents.css('padding-top', navHeight);
      $contents.css('margin-top', '122px');
      $contents_osaka.css('margin-top', '75px');
      // $contents.css('margin-top', navHeight);
    } else {
      $nav.removeClass(fixedClass);
      // $contents.css('padding-top', '0');
      // $contents.css('padding-top', '0');
      $contents.css('margin-top', '0');
      $contents_osaka.css('margin-top', '0');
    }
  });
  $('.is-home a[href^="#"]').click(function() {
    $nav = $('.nav-main');
    var navHeight = $nav.outerHeight();
    var speed = 800;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - navHeight;
    
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    
    return false;
  });

  // グッズ用スクロール
  $('.page-anchor a[href^="#"]').click(function() {
    var speed = 800;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - 120;
    
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    
    return false;
  });

  // キャンペーン用スクロール
  $('.news-list a[href^="#"]').click(function() {
    var speed = 800;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - 120;
    
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    
    return false;
  });
}
// $(window).on('load', function() {
//     // $nav = $('.nav-main');
//     // var navHeight = $nav.outerHeight();
//     var url = $(location).attr('href');
//     if(url.indexOf("?id=") != -1){
//         var id = url.split("?id=");
//         var $target = $('#' + id[id.length - 1]);
//         if($target.length){
//             var pos = $target.offset().top - 122;
//             $("html, body").animate({scrollTop:pos}, 3000);
//         }
//     }
// });

// SPメニュー
if(navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)){
    var $open = $('#open');
    var $menu = $('.open-menu');
    var stopScroll = false;
    var $window = $(window);
    var headerHeight = $('.js-header').height();
    var pageType = '<?php echo $pageType; ?>';
    var $document = $(document);
    var event = 'ontouchstart' in window ? 'touchend' : 'click';

    $open.on(event, function(e) {
        e.stopPropagation();
        $menu.toggleClass('open');
        if (!stopScroll) {
          stopScroll = true;
          // $window.on('touchmove.noScroll', function(e) {
          //   e.preventDefault();
          // });
        }
    });
    $('#close, .sp-list a').on(event, function(e) {
        e.stopPropagation();
        $menu.removeClass('open');
        stopScroll = false;
        $window.off('.noScroll');
    });

  // ページ内スクロールSP時

  $('.is-home a[href^="#"]').click(function() {
    $nav = $('.sp-menu');
    var navHeight = $nav.outerHeight();
    var speed = 800;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - navHeight;
    
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    
    return false;
  });

  // グッズ用スクロール
  $('.page-anchor a[href^="#"]').click(function() {
    $nav = $('.sp-menu');
    var navHeight = $nav.outerHeight();
    var speed = 800;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - navHeight;
    
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    
    return false;
  });

}

$(window).on('load',function(){
  if(!document.URL.match('osaka_special.html')) {
  　if(document.URL.match('share.html') || document.URL.match('special.html')) {
      if(document.URL.match('www.tv-asahi.co.jp/')) {
        window.location.href = '/thedoraemontentokyo2017';
      } else {
         window.location.href = '/';    
      }
  　}
  }
});

// 右クリック禁止処理(今回はスペシャルページのみに適用)
$('#program-not-download').on('mousedown mouseup contextmenu', function (e) {
  return false;
});


// WEBPACK FOOTER //
// ./app/src/js/main.js